'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _editor = require('../editor');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_jquery2.default.fn.DataTable.Api.register('cell().editable()', function () {
	return (0, _editor.isEditable)(this.column(this.node()), this.row(this.node()).data());
});


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/data-tables/api/cell-extensions.js
// module id = 473
// module chunks = 0